import { CaixaProps } from "../../components/Estrutura/Caixa";

export const salaA: CaixaProps[] = [
  {
    nome: "Sala A",
    descricao: "Bateria - Sala A",
    img: "/assets/Estudio/IMG_4360.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Espaço social - Sala A",
    img: "/assets/Estudio/IMG_4368.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Visão Superior - Sala A",
    img: "/assets/Estudio/IMG_8734.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Visão geral - Sala A",
    img: "/assets/Estudio/IMG_8746.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Visão geral - Sala A",
    img: "/assets/Estudio/IMG_8757.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Visão geral - Sala A",
    img: "/assets/Estudio/IMG_9004.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Visão bateria - Sala A",
    img: "/assets/Estudio/IMG_8998.jpg",
  },
  {
    nome: "Sala A",
    descricao: "Guitarra - Sala A",
    img: "/assets/Estudio/IMG_8726.jpg",
  },
];
